var _rect, _rect2, _rect3, _rect4, _rect5, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid05(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 124,
    viewBox: "0 0 178 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 178,
    height: 124,
    fill: "white",
    fillOpacity: 0.12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.68408,
    y: 9.36792,
    width: 170.193,
    height: 106.175,
    rx: 3.12281,
    fill: "#616161"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 134.28,
    y: 28.1062,
    width: 39.0351,
    height: 23.4211,
    rx: 3.12281,
    fill: "#858585"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 134.28,
    y: 54.6501,
    width: 39.0351,
    height: 23.4211,
    rx: 3.12281,
    fill: "#858585"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 134.28,
    y: 81.1919,
    width: 39.0351,
    height: 21.8596,
    rx: 3.12281,
    fill: "#858585"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.28 109.299C134.28 107.574 135.678 106.176 137.403 106.176H170.192C171.917 106.176 173.315 107.574 173.315 109.299V112.422H134.28V109.299Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid05);
export default __webpack_public_path__ + "static/media/grid_05.6bc3c7ede3e9fbbe2dda768fd1b63031.svg";
export { ForwardRef as ReactComponent };